<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2K6vNK/tc-custom/9781939867773.jpg?1714677688419" alt="This image is the cover for the book Something is Killing the Children Vol. 7, Something is Killing the Children"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Something is Killing the Children Vol. 7, Something is Killing the Children
      </h1>
      <p class="bookDescription body article font2">
        <p>After narrowly surviving the Duplicitype, Erica Slaughter must still reckon with the murderous Cutter in order to save the people of Tribulation. Separated from Dolly and driven by desperate rage, Cutter won't stop until she exacts her revenge on Erica. But the horror is far from over as the terrifying Duplicitype, the infamous monster wearing Erica’s likeness that changed Something is Killing the Children forever, also remains at large and in relentless, sinister pursuit! And with Cecilia showing up onsite, will Erica finally find the ally she needs, or is betrayal in the cards? Whose side are they on? Most importantly, what chance does Erica stand? Collects Something is Killing the Children #31-35.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Tynion IV, Werther Dell’Edera
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61657ff2